export const GET_ALERTS = 'GET_ALERTS';
export const GET_ALERT_SUCCESS = "GET_ALERT_SUCCESS";
export const GET_ALERT_ERROR = "GET_ALERT_ERROR";